import { render, staticRenderFns } from "./LayoutFolderWithoutPrices.vue?vue&type=template&id=4ba08716&"
import script from "./LayoutFolderWithoutPrices.vue?vue&type=script&lang=js&"
export * from "./LayoutFolderWithoutPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports